export enum WarningType{
  NoWarning = 0,
  DayShiftTotalHour = 1,
  NightShiftTotalHour = 2,
  OffTotalHour = 3,
  ShiftCodeNotMatchRosterCode = 4,
  IncorrectRosterCode = 5,
  MissingTimesheet = 6,
  MoreThan12Hours = 7
}